import React, { useState } from "react";
import styles from "./MobileVersion.module.css";
import EnqueryModal from "./EnqueryModal";
import {
  CarouselProvider,
  Slider,
  Slide,
  Dot,
  ButtonBack,
  ButtonNext,
} from "pure-react-carousel";
import { useNavigate } from "react-router-dom";
import MediaAssets from "assets";
import { LazyLoadImage } from "react-lazy-load-image-component";
import EnqueryForm from "../enquery-form/EnqueryForm";
import sessionStorage from "redux-persist/es/storage/session";

const MobileVersion = (props: any) => {
  const [opeModal, setopeModal] = useState<any>(false);
  const [projectname, setprojectname] = useState<any>("");
  const [openEnqModal, setopenEnqModal] = useState(false);
  const navigate = useNavigate();

  const handleRedirect = (data: any) => {
    navigate(`/investment-details/${data.launchName.replace(/%20|\s/g, "-")}`, {
      state: {
        projectId: data.id,
        area: data?.areaStartingFrom,
        cost: data.priceStartingFrom,
        title: data.launchName,
        location: data.address.city,
        description: data.shortDescription,
        isDetailed: data.isSoldOut,
        isExplore: data.isSoldOut,
        isSold: data.isSoldOut,
        dataAsObject: data,
      },
    });
  };



  return (
    <>
      {opeModal && <EnqueryForm setAyodhya={true} />}
      <div className={styles.MobileCommonSlider}>
        <CarouselProvider
          naturalSlideWidth={100}
          naturalSlideHeight={192}
          totalSlides={props?.sliderData?.length}
          isPlaying={true}
          interval={10000}
        >
          <Slider>
            {props?.sliderData &&
              props?.sliderData?.map((data: any, ind: number) => {
                return (
                  <Slide
                    index={ind}
                    onClick={() => {
                      setprojectname(data?.launchName);
                      if (ind === 0) {
                        navigate("/ayodhya");
                      } else {
                        navigate("/goa");
                      }
                    }}
                  >
                    <div className={styles.slider_wrapper}></div>
                    <div style={{ height: "100%"}}>
                      <div className={styles.icon}>
                        <LazyLoadImage
                          className={styles.iconImg}
                          src={data?.projectIcon?.value?.url}
                        />
                      </div>
                      <div style={{ height: "100%" }} className={styles.imgCon}>
                        <LazyLoadImage
                          src={data?.bannerImage?.value?.url}
                          className={styles.slider_img_style}
                          alt="Landing page"
                        />
                      </div>
                      <div className={styles.bottom_div_style}>
                        <div>
                          <h4 className={styles.bottom_heading}>
                            {data?.launchName}
                          </h4>
                          <p className={styles.content_style}>
                            {data?.shortDescription}
                          </p>
                        </div>
                        <div className={styles.explore_div_style}>
                          <LazyLoadImage
                            src={MediaAssets.subtract}
                            className={styles.subtract_img_style}
                            alt="Landing page"
                          />
                          <div className={styles.explore_heading_style}>
                            <LazyLoadImage
                              src={MediaAssets.globe}
                              style={{ marginRight: "9px" }}
                              alt="Landing page"
                            />
                            <h4 className={styles.explore_heading}>
                              Explore Now
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Slide>
                );
              })}
          </Slider>
          <div className={styles.dot_wrapper}>
            {props?.sliderData &&
              props?.sliderData?.map((index: number) => {
                return <Dot slide={index} className={styles.dot_style} />;
              })}
          </div>
        </CarouselProvider>
      </div>
    </>
  );
};

export default MobileVersion;
